package com.nonopn.skydome.common.app.pages.account

import androidx.compose.ui.platform.UriHandler
import kotlinx.browser.window

// Same tab: a new tab opened after the asynchronous call would be blocked by the popup blocker.
@Suppress("UnusedParameter", "UNUSED_PARAMETER")
actual fun openUrlAfterAsyncCall(uriHandler: UriHandler, url: String) {
    window.location.href = url
}
